import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import axiosInstance from '../../../../../interceptor/axiosInstance';
import './AddNewOptions.css';

// Toast notification functions
const toast = {
  success: (message) => {
    const toastEl = document.createElement('div');
    toastEl.className = 'add-option-toast add-option-toast-success';
    toastEl.textContent = message;
    document.body.appendChild(toastEl);
    setTimeout(() => toastEl.classList.add('add-option-toast-show'), 10);
    setTimeout(() => {
      toastEl.classList.remove('add-option-toast-show');
      setTimeout(() => document.body.removeChild(toastEl), 300);
    }, 3000);
  },
  error: (message) => {
    const toastEl = document.createElement('div');
    toastEl.className = 'add-option-toast add-option-toast-error';
    toastEl.textContent = message;
    document.body.appendChild(toastEl);
    setTimeout(() => toastEl.classList.add('add-option-toast-show'), 10);
    setTimeout(() => {
      toastEl.classList.remove('add-option-toast-show');
      setTimeout(() => document.body.removeChild(toastEl), 300);
    }, 3000);
  },
};

const AddNewOptions = ({ questionID, onClose, onSaveSuccess }) => {
  const [text, setText] = useState('');
  const [isCorrect, setIsCorrect] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!text.trim() && !image) {
      toast.error('Please provide option text or an image');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('question', questionID);
    formData.append('text', text);
    formData.append('is_correct', isCorrect ? 'true' : 'false');
    if (image) {
      formData.append('image', image);
    }

    try {
      const response = await axiosInstance.post(
        'assessments/options/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 201) {
        toast.success('Option added successfully!');
        onSaveSuccess();
        onClose();
      }
    } catch (error) {
      console.error('Error saving option:', error);
      const errorMsg =
        error.response?.data?.errors?.image?.[0] ||
        error.response?.data?.message ||
        'Failed to save option';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const modalContent = (
    <div className="add-option-modal-overlay" onClick={onClose}>
      <div className="add-option-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="add-option-modal-header">
          <h2 className="add-option-modal-title">➕ Add New Option</h2>
          <button className="add-option-modal-close" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="add-option-modal-body">
          {/* Option Text */}
          <div className="add-option-form-group">
            <label className="add-option-label">
              Option Text <span className="add-option-required">*</span>
            </label>
            <textarea
              className="add-option-textarea"
              value={text}
              onChange={(e) => setText(e.target.value)}
              rows={3}
              placeholder="Enter option text..."
            />
          </div>

          {/* Correct Checkbox */}
          <div className="add-option-form-group">
            <label className="add-option-checkbox-label">
              <input
                type="checkbox"
                className="add-option-checkbox"
                checked={isCorrect}
                onChange={(e) => setIsCorrect(e.target.checked)}
                id="isCorrectCheckbox"
              />
              <span className="add-option-checkbox-text">Mark as Correct Answer</span>
            </label>
          </div>

          {/* Image Upload */}
          <div className="add-option-form-group">
            <label className="add-option-label">Option Image (Optional)</label>
            {imagePreview && (
              <div className="add-option-image-preview-wrapper">
                <img src={imagePreview} alt="Preview" className="add-option-image-preview" />
              </div>
            )}
            <input
              type="file"
              id="add-option-image-upload"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />
            <button
              type="button"
              className="add-option-upload-btn"
              onClick={() => document.getElementById('add-option-image-upload').click()}
            >
              📷 {imagePreview ? 'Change Image' : 'Upload Image'}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="add-option-modal-footer">
          <button className="add-option-cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="add-option-save-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="add-option-btn-spinner"></span>
                Saving...
              </>
            ) : (
              '➕ Add Option'
            )}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default AddNewOptions;
